import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const Hamburger = ({ onClick }) => {
  return (
    <div onClick={onClick} className="hamburger-container">
      <div className="hamburger-bar"/>
      <div className="hamburger-bar"/>
      <div className="hamburger-bar"/>
    </div>
  );
};

Hamburger.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default Hamburger;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/Hamburger/index.js
 **/